import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "courseware-audio-player" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "courseware-audio-player__card" }
const _hoisted_4 = { class: "courseware-audio-player__controls" }
const _hoisted_5 = ["disabled", "aria-label"]
const _hoisted_6 = {
  key: 0,
  viewBox: "0 0 24 24",
  "aria-hidden": "true"
}
const _hoisted_7 = {
  key: 1,
  viewBox: "0 0 24 24",
  "aria-hidden": "true"
}
const _hoisted_8 = { class: "courseware-audio-player__timeline" }
const _hoisted_9 = { class: "courseware-audio-player__time" }
const _hoisted_10 = { class: "courseware-audio-player__seek-wrap" }
const _hoisted_11 = { class: "courseware-audio-player__seek-track" }
const _hoisted_12 = ["value", "disabled"]
const _hoisted_13 = { class: "courseware-audio-player__time" }
const _hoisted_14 = ["disabled", "aria-label"]
const _hoisted_15 = {
  key: 0,
  viewBox: "0 0 24 24",
  "aria-hidden": "true"
}
const _hoisted_16 = {
  key: 1,
  viewBox: "0 0 24 24",
  "aria-hidden": "true"
}

import { useCoursewareAudio } from '@/components/timetable/coursewareAudio/useCoursewareAudio';


export default /*@__PURE__*/_defineComponent({
  __name: 'CoursewareAudioPlayer',
  setup(__props) {

const {
  audioUrl,
  loading,
  playing,
  muted,
  seekValue,
  visible,
  currentTimeLabel,
  durationLabel,
  progressPercent,
  bindAudioRef,
  togglePlay,
  toggleMute,
  onTimeUpdate,
  onLoadedMetadata,
  onAudioEnded,
  onSeekInput,
  onSeekStart,
  onSeekEnd,
} = useCoursewareAudio();

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("audio", {
      ref: _unref(bindAudioRef),
      src: _unref(audioUrl),
      preload: "metadata",
      onTimeupdate: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(onTimeUpdate) && _unref(onTimeUpdate)(...args))),
      onLoadedmetadata: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(onLoadedMetadata) && _unref(onLoadedMetadata)(...args))),
      onEnded: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(onAudioEnded) && _unref(onAudioEnded)(...args)))
    }, null, 40, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          type: "button",
          class: "courseware-audio-player__play",
          disabled: _unref(loading) || !_unref(audioUrl),
          "aria-label": _unref(playing) ? '暂停' : '播放',
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(togglePlay) && _unref(togglePlay)(...args)))
        }, [
          (_unref(playing))
            ? (_openBlock(), _createElementBlock("svg", _hoisted_6, _cache[9] || (_cache[9] = [
                _createElementVNode("rect", {
                  x: "6",
                  y: "5",
                  width: "4.5",
                  height: "14",
                  rx: "1.2",
                  fill: "currentColor"
                }, null, -1),
                _createElementVNode("rect", {
                  x: "13.5",
                  y: "5",
                  width: "4.5",
                  height: "14",
                  rx: "1.2",
                  fill: "currentColor"
                }, null, -1)
              ])))
            : (_openBlock(), _createElementBlock("svg", _hoisted_7, _cache[10] || (_cache[10] = [
                _createElementVNode("path", {
                  d: "M8 6.2v11.6c0 .9 1 .4 1.4-.2l7.8-5.4c.5-.4.5-1.2 0-1.6l-7.8-5.4c-.4-.6-1.4-1.1-1.4-.2z",
                  fill: "currentColor"
                }, null, -1)
              ])))
        ], 8, _hoisted_5),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(currentTimeLabel)), 1),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", {
                class: "courseware-audio-player__seek-fill",
                style: _normalizeStyle({ width: `${_unref(progressPercent)}%` })
              }, null, 4)
            ]),
            _createElementVNode("input", {
              class: "courseware-audio-player__seek",
              type: "range",
              min: "0",
              max: "100",
              step: "0.1",
              value: _unref(seekValue),
              disabled: _unref(loading) || !_unref(audioUrl),
              "aria-label": "音频进度",
              onInput: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_unref(onSeekInput) && _unref(onSeekInput)(...args))),
              onPointerdown: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_unref(onSeekStart) && _unref(onSeekStart)(...args))),
              onPointerup: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_unref(onSeekEnd) && _unref(onSeekEnd)(...args))),
              onPointercancel: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_unref(onSeekEnd) && _unref(onSeekEnd)(...args)))
            }, null, 40, _hoisted_12)
          ]),
          _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(durationLabel)), 1)
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "courseware-audio-player__mute",
          disabled: _unref(loading) || !_unref(audioUrl),
          "aria-label": _unref(muted) ? '取消静音' : '静音',
          onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_unref(toggleMute) && _unref(toggleMute)(...args)))
        }, [
          (_unref(muted))
            ? (_openBlock(), _createElementBlock("svg", _hoisted_15, _cache[11] || (_cache[11] = [
                _createElementVNode("path", {
                  d: "M5 10v4",
                  stroke: "currentColor",
                  "stroke-width": "1.8",
                  "stroke-linecap": "round"
                }, null, -1),
                _createElementVNode("path", {
                  d: "M9 7.5v9l6.5-4.5-6.5-4.5z",
                  fill: "currentColor"
                }, null, -1),
                _createElementVNode("path", {
                  d: "M16 9l4 6M20 9l-4 6",
                  stroke: "currentColor",
                  "stroke-width": "1.6",
                  "stroke-linecap": "round"
                }, null, -1)
              ])))
            : (_openBlock(), _createElementBlock("svg", _hoisted_16, _cache[12] || (_cache[12] = [
                _createElementVNode("path", {
                  d: "M5 10v4",
                  stroke: "currentColor",
                  "stroke-width": "1.8",
                  "stroke-linecap": "round"
                }, null, -1),
                _createElementVNode("path", {
                  d: "M9 7.5v9l6.5-4.5-6.5-4.5z",
                  fill: "currentColor"
                }, null, -1),
                _createElementVNode("path", {
                  d: "M17 9.5c1.2 1 1.2 4 0 5",
                  stroke: "currentColor",
                  "stroke-width": "1.6",
                  "stroke-linecap": "round"
                }, null, -1),
                _createElementVNode("path", {
                  d: "M19.5 7c2 1.8 2 6.2 0 8",
                  stroke: "currentColor",
                  "stroke-width": "1.6",
                  "stroke-linecap": "round"
                }, null, -1)
              ])))
        ], 8, _hoisted_14)
      ])
    ])
  ], 512)), [
    [_vShow, _unref(visible)]
  ])
}
}

})